module.exports = __webpack_public_path__ + "img/lv18.3791701c.png";